import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
const ObLink = dynamic(() => import('../ObLink/ObLink'));
const Icon = dynamic(() => import('../Icon/Icon'));
import Loader from '../../adapters/helpers/Loader';

export default function BrandGuarantee(props) {
    const {extraAttributes} = props;

    const brandGuarantee = extraAttributes?.entity?.brandGuarantee;
    const claims = brandGuarantee?.fields?.claims;
    const ctaLabel = brandGuarantee?.fields?.ctaLabel;
    const ctaLink = brandGuarantee?.fields?.ctaLink;
    const anchorId = brandGuarantee?.fields?.anchorId;
    const classNames = brandGuarantee?.fields?.classNames || '';

    return (
        <>
        { claims &&
            <div className={'ob-brand-guarantee ' + classNames} id={anchorId} >
                {claims.map((claim, i) => {
                    const iconId = claim?.fields?.iconId;
                    const statistic = claim?.fields?.statistic;
                    const title = claim?.fields?.title;

                    return (
                        <Suspense fallback={<Loader />}>
                        <div className='ob-brand-guarantee__claim' key={i} title={title}>
                            {iconId && <div aria-hidden='true' className='ob-brand-guarantee__icon'><span className={'icon-' + iconId}/></div>}
                            {statistic && <div className='ob-brand-guarantee__statistic'>{statistic}</div>}
                        </div>
                        </Suspense>
                    );
                })}
                {ctaLink && ctaLabel &&
                <Suspense fallback={<Loader />}>
                    <div className='ob-brand-guarantee__cta-link'>
                        <ObLink href={ctaLink}
                                className='white event_internal_link'
                                data-action-detail={ctaLabel}>
                            {ctaLabel}
                            <Icon size={0.7} color='black' name='chevronRight' />
                        </ObLink>
                    </div>
                </Suspense>
                    }
            </div>
        }
        </>
    );
}

BrandGuarantee.propTypes = {
    extraAttributes: PropTypes.object,
};